export enum footerActionsTypes {
  GET_FOOTER_ITMES_REQUEST = 'GET_FOOTER_ITMES_REQUEST',
  GET_FOOTER_ITMES_SUCCESS = 'GET_FOOTER_ITMES_SUCCESS',
  GET_FOOTER_ITMES_FAILURE = 'GET_FOOTER_ITMES_FAILURE',
}
